type Registration = App.Domain.Registration.Data.RegistrationData;

export const statusLabels: {
  [key in 'created' | 'crewQuantityRequested' | 'crewQuantityWaitingForApproval' | 'approved']: string;
} = {
  created: 'Created',
  crewQuantityRequested: 'Quantities Requested',
  crewQuantityWaitingForApproval: 'Waiting for Approval',
  approved: 'Approved',
};
